import { dehydrate, hydrate, type Query, type QueryClient } from '@tanstack/react-query';
import { idbClear, idbGet, idbSet } from './idb.js';

/**
 * Keeps the checks you've opened (and who you are) on the phone, so the app
 * can reopen them with no signal — a shed or truck bay — and carry on.
 * Only check data is kept, for a week; signing out clears it.
 */

const KEY = 'queries';
const MAX_AGE = 7 * 86400_000;

function kept(q: Query): boolean {
  if (q.state.status !== 'success') return false;
  const [a, , c] = q.queryKey as unknown[];
  return a === 'me' || a === 'check-items' || (a === 'orgs' && c === 'check-runs');
}

export async function restoreQueries(qc: QueryClient): Promise<void> {
  const saved = await idbGet<{ at: number; state: unknown }>('cache', KEY);
  if (saved && Date.now() - saved.at < MAX_AGE) {
    try { hydrate(qc, saved.state); } catch { /* an older shape: start fresh */ }
  }
  let t: ReturnType<typeof setTimeout> | undefined;
  qc.getQueryCache().subscribe(() => {
    clearTimeout(t);
    t = setTimeout(() => void idbSet('cache', KEY, { at: Date.now(), state: dehydrate(qc, { shouldDehydrateQuery: kept }) }), 1500);
  });
}

export const clearSavedQueries = () => idbClear('cache');
